import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.report.util.lift`, {
  'reports.chart-types.disabled-reasons.experiment-comparison': `Experiment comparison is not available for {{chartType}}`,
  'reports.chart-types.disabled-reasons.overall-comparison': `Overall comparison is not available for {{chartType}}`,
  'reports.chart-types.disabled-reasons.percent-change': `{{chartType}} is not available with percent change over time`,
  'reports.chart-types.disabled-reasons.segment-comparison': `Segment comparison is not available for {{chartType}}`,
  'reports.chart-types.labels.chart': `{{chartType}} chart`,
  'reports.chart-types.labels.stacked': `Stacked {{chartType}}`,
  'reports.lift-comparison.experiment-description': `experiment comparison`,
  'reports.lift-comparison.overall-description': `overall comparison`,
  'reports.lift-comparison.period-description': `percent change over time`,
  'reports.lift-comparison.segment-description': `segment comparison`,
});
